import { render, staticRenderFns } from "./myCoupon.vue?vue&type=template&id=5b8395de&scoped=true"
import script from "./myCoupon.vue?vue&type=script&lang=js"
export * from "./myCoupon.vue?vue&type=script&lang=js"
import style0 from "./myCoupon.vue?vue&type=style&index=0&id=5b8395de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8395de",
  null
  
)

export default component.exports